import { render, staticRenderFns } from "./base-checkbox.vue?vue&type=template&id=c247f93c"
import script from "./base-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./base-checkbox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-checkbox.vue?vue&type=style&index=0&id=c247f93c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports